<template>
    <div class="game game-1">
        <TimeCounter
            ref="timeCounter"
            :time="duration"
            @due="onDue"
            @tick="onTick"
        />
        <Score />
        <Question :selected="selected">
            <template v-slot:question>
                <span class="question" :style="questionFontSize">
                    {{ questionConfig.question
                    }}<span v-if="questionConfig.question">是含醣食物嗎？</span>
                </span>
            </template>
        </Question>
        <Reaction
            :image="questionConfig.image"
            :hint="questionConfig.hint"
            :answer="questionConfig.answer"
            :selected="selected"
        />
        <Footer type="game1" :level="$route.params.level" :correct="correct">
            <img
                :src="
                    require(`@/assets/Stage/Game/game1/level${$route.params.level}/bg.png`)
                "
                alt=""
                width="100%"
            />
        </Footer>
        <AnswerWrapper bottom="5%">
            <img
                :src="require(`@/assets/Stage/Game/game1/yes.png`)"
                alt=""
                @click="onAnswer(1)"
            />
            <img
                :src="require(`@/assets/Stage/Game/game1/no.png`)"
                alt=""
                @click="onAnswer(0)"
            />
        </AnswerWrapper>
        <transition name="fade" mode="out-in">
            <PopupWrapper v-if="popup" @ready="onReady" button-color="#56a1e6">
                遊戲採「<strong>是非題</strong>」，總計<strong>{{totalQuestions}}題</strong>，每次限時{{
                    duration
                }}秒，答對<strong>+{{ correctScore }}</strong
                >分，<strong>1秒內</strong>答對分數<strong>{{ "兩倍" }}</strong
                >，剩餘時間<strong
                    >每{{ bonusExchangeConstant }}秒獲得1分</strong
                >
                <template v-if="!isInEvent"
                    >，挑戰累積到一定分數後就可以在「<strong>闖關進度塔</strong>」裡解鎖道具喔！
                </template>
            </PopupWrapper>
        </transition>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GlobalConfig from '@/config/global';
import Question from '@/components/Stage/Game/Components/Game1Question.vue';
import Reaction from '@/components/Stage/Game/Components/Game1Reaction.vue';
import Config from '@/config/question/game1';
import mixins from '../mixins';

export default {
    components: { Reaction, Question },
    mixins: [mixins],
    computed: {
        ...mapGetters(['isInEvent']),
        questionFontSize() {
            const QUESTION_LENGTH = this.questionConfig.question?.length;
            if (QUESTION_LENGTH > 3) return { 'font-size': '1.7rem' };
            return {};
        },
    },
    data() {
        return {
            config: null,
            bonusExchangeConstant: null,
            // preload
            loaded: 0,
        };
    },
    created() {
        this.config = Config;
        this.bonusExchangeConstant = GlobalConfig.bonusExchangeConstant;
    },
    mounted() {
        this.onPreload();
    },
    methods: {
        onAnswer(answer) {
            if (this.selected !== undefined) return;
            this.answeredQuestionAmount += 1;
            this.selected = answer;
            this.correct = this.questionConfig.answer === answer;
            this.handleAfterAnswer(this.correct);

            if (this.correct) {
                this.onChangeQuestion(this.config.correctDuration * 1000);
            } else this.onChangeQuestion(this.config.incorrectDuration * 1000);
        },
        onPreload() {
            console.log('start loading image');
            this.questionPool.forEach((item) => {
                const IMAGE_URL = `${process.env.VUE_APP_API_URL}${item.image}`;
                this.loadImage(IMAGE_URL);
            });
        },
        async loadImage(path) {
            try {
                const IMG = new Image();
                IMG.onload = this.onLoad;
                const RES = await fetch(path);
                if (RES.status === 404) throw new Error('not found');
                else IMG.src = path;
            } catch (e) {
                console.log('pic not found');
                this.onLoad();
            }
        },
        onLoad() {
            this.loaded += 1;
            if (this.loaded === this.totalQuestions) {
                this.$emit('ready');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../style.scss";
.game-1 > .question {
    font-size: 2.06rem;
}
</style>
